import React from 'react';
import styles from './styles.module.css';

type Props = { label: string; children: React.ReactNode; className?: string };

const FormGroup = ({ label, children, className = '' }: Props) => (
  <div className={[styles['form-group'], className].join(' ')}>
    {label && <div className={styles['form-group__label']}> {label} </div>}
    <div className='form-group__body'>{children}</div>
  </div>
);

export default FormGroup;
